import h from "../core/createElement";
import Btn from "./btn";

export default function SearchBar({ placeholder = "", onSearch, shared = {}, name = "searchbar" }) {

    const
        input = <input type="text" placeholder={placeholder} onKeypress={(evt) => { if (evt.key == "Enter") handle_change() }} />,
        bar = (
            <article class="search-bar align-center">
                <article class="input">
                    <Btn icon="assets/image/x.svg" color="" onClick={() => close()} />
                    {input}
                    <Btn icon="assets/image/magnifying-glass.svg" color="pink" onClick={() => handle_change()} />
                </article>
                <Btn icon="assets/image/magnifying-glass.svg" containerClass="open-btn" color="pink" onClick={() => open()} />
            </article>
        );

    let value = '';

    shared[name] = {
        close: () => {
            value = "";
            close();
        },
        open: () => { open() }
    };

    function handle_change() {
        if (value == input.value) return;
        onSearch && onSearch(value = input.value)
    };

    function open() {
        bar.classList.add('open');
        input.focus();
    };

    function close() {
        if (!bar.classList.contains("open")) return;
        bar.classList.remove('open');
        bar.classList.add('close');
        bar.addEventListener('animationend', _close_overal);
    };

    const _close_overal = () => {
        bar.classList.remove('close');
        bar.classList.remove('open');
        bar.removeEventListener('animationend', _close_overal);

        if (value != "") onSearch && onSearch("");
        value = input.value = "";
    };

    return bar;
};